import { render, staticRenderFns } from "./States.vue?vue&type=template&id=85f6b728&scoped=true&"
import script from "./States.vue?vue&type=script&lang=js&"
export * from "./States.vue?vue&type=script&lang=js&"
import style0 from "./States.vue?vue&type=style&index=0&id=85f6b728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f6b728",
  null
  
)

export default component.exports